import SheetsPage from "../features/sheets/SheetsPage";

export default function SheetsRoute() {
  return <SheetsPage />;
}
